import React from "react"
import DocumentDetails from "./DocumentDetails"
import gql from "graphql-tag"
import { graphql } from "@apollo/client/react/hoc"
import { Row, Col, Card, Button, UncontrolledTooltip, Alert } from "reactstrap"
import Skeleton from "react-loading-skeleton"
import 'react-loading-skeleton/dist/skeleton.css'
import { isImage, cleanDocumentUrl } from "../../Material/DocumentModal/DocumentsListNew"
import DatetimeRenderer from "../../Material/DatetimeRenderer"
import withApolloClient from "../../withApolloClient"
import UploadIncidentDocumentModal from "../Components/UploadIncidentDocumentModal"
import DocumentModalNew from "../../Material/DocumentModal/DocumentModalNew"
import "./DocumentsTab.css"

const GENERATE_PDF = gql`mutation generatePdfFromImages($input: GeneratePDFFromImagesMutationInput!) {
  generatePdfFromImages(input: $input) {
    ok
    base64String
    errors { 
        messages
    }
  }
}`

const AllIncidentDocumentsQuery = gql`query AllIncidentDocuments($incidentId: ID!, $slug: String, $isArchived: Boolean, $first: Int, $after: String) {
    allIncidentDocuments(incidentId: $incidentId, slug: $slug, isArchived: $isArchived, first: $first, after: $after, orderBy: ["-date_added"]) {
      edges {
        node {
          id
          dateAdded
          isArchived
          documentType{ 
            id 
            typeName: name
            }
          url
          document
          notes
          createdBy { 
            id 
            username
          }
          history { 
            date 
            user 
            comment
            }
        }
      }
      pageInfo{ 
        endCursor 
        hasNextPage 
      }
    }
}`

const AllCarPicturesQuery = gql`
  query AllCarPictures($incidentId: ID!) {
    allCarPictures(incidentId: $incidentId) {
      edges {
        node {
          id
          dateAdded
          pictureUrl
          pictureType
          description
        }
      }
    }
  }
`

class DocumentList extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
            documents: [],
            selectedDocument: null,
            selectedDocs: [],
            pdfBase64: null,
            error: null,
            loading: false
        }
    }

    toggleSelectDoc = (doc) => {
        let selected = [...this.state.selectedDocs]
        const exists = selected.find(d => d.id === doc.id)

        if (exists) selected = selected.filter(d => d.id !== doc.id)
        else selected.push(doc)

        this.setState({ selectedDocs: selected })
    }

    pdfHandler = async () => {
        this.setState({ loading: true, error: null })
        const docs = this.state.selectedDocs.map(d => ({
            bucketPath: d.document && !d.pictureUrl ? d.document : null,
            imageUrl: d.pictureUrl || null,
            title: d.documentType?.typeName || "Document"
        }))
        try {
            const result = await this.props.apolloClient.mutate({
                mutation: GENERATE_PDF,
                variables: {
                    input: {
                        documents: docs,
                        imagesPerPage: 2
                    }
                }
            })
            if (result.data?.generatePdfFromImages?.ok) {
                this.setState({ pdfBase64: result.data?.generatePdfFromImages?.base64String, loading: false, selectedDocs: [] })
            } else {
                this.setState({ error: "Failed to generate PDF.", loading: false })
            }
        } catch (err) {
            this.setState({ error: "An error occurred: " + err.message, loading: false })
        }
    };


    refetchQuery = () => {
        this.props.refetchDocumentsQuery && this.props.refetchDocumentsQuery()
    }
    viewDocuments = (documents, index = 0) => {
        documents = documents.map(doc => ({ documentUrl: cleanDocumentUrl(doc.node.pictureUrl || doc.node.url), id: doc.node.id, name: doc.node.pictureType || doc.node.document, documentType: doc.node.documentType, description: doc.node.description || doc.node.notes, dateAdded: doc.node.dateAdded }))
        this.setState({ documents: documents, selectedDocument: documents[index] })
    }
    next = () => {
        const documents = this.state.documents
        const currentIndex = documents.findIndex(item => item.id === this.state.selectedDocument.id)
        if (currentIndex === documents.length - 1) return
        this.setState({ selectedDocument: documents[currentIndex + 1] })
    }

    prev = () => {
        const documents = this.state.documents
        const currentIndex = documents.findIndex(item => item.id === this.state.selectedDocument.id)
        if (currentIndex === 0) return
        this.setState({ selectedDocument: documents[currentIndex - 1] })
    }
    render() {
        const { loading, allIncidentDocuments, allCarPictures, isArchived } = this.props
        const documentEdges = allIncidentDocuments?.edges || []
        return (
            <>
                {this.state.error && <Alert color="danger">{this.state.error}</Alert>}
                {this.state.pdfBase64 &&
                    <DocumentModalNew
                        document={{
                            documentUrl: `data:application/pdf;base64,${this.state.pdfBase64}`,
                            name: "Generated PDF"
                        }}
                        isPicture={false}
                        handleClose={() => this.setState({ pdfBase64: null })}
                    />
                }
                {this.state.selectedDocs.length > 0 && (
                    <div className="floating-btn-container">
                        <Button className="download-btn" id="download-btn" color="success" onClick={this.pdfHandler} disabled={this.state.loading}>
                            {this.state.loading ? <div className="spinner-border spinner-border-sm" /> : <i className="fa fa-download" />}
                        </Button>
                        <UncontrolledTooltip target="download-btn" placement="left">Download Selected as PDF</UncontrolledTooltip>
                    </div>
                )}

                {!isArchived && <div className="text-right mb-2">
                    <Button color="primary" onClick={() => this.setState({ openModal: "uploadIncidentDocument" })}>
                        Upload Document
                    </Button>
                    {this.state.openModal === "uploadIncidentDocument" && (
                        <UploadIncidentDocumentModal
                            incidentId={this.props.id}
                            isOpen={this.state.openModal === "uploadIncidentDocument"}
                            toggle={() => this.setState({ openModal: "" })}
                            refetchQuery={this.props.refetchDocumentsQuery}
                            documentCategory={this.props.slug?.split("_")[0] || ""}
                            slug={this.props.slug}
                        />
                    )}
                </div>}
                {loading && <Row>
                    {[...Array(10)].map((_, index) => (
                        <Col className="mt-3" xs={4} key={index}>
                            <Skeleton count={1} height={50} />
                        </Col>
                    ))}
                </Row>}
                {this.state.selectedDocument &&
                    <DocumentModalNew
                        document={this.state.selectedDocument}
                        handleClose={() => this.setState({ selectedDocument: null })}
                        next={this.next}
                        prev={this.prev}
                        objectType={"picture"}
                        isPicture={true}
                        refetch={this.props.refetch}
                        currentUser={this.props.currentUser}
                    />
                }
                <div className="DocumentCardContainer">
                    {!loading && documentEdges.length > 0 ? (documentEdges.map((document, idx) => (
                        <DocumentDetails
                            key={document.node.id}
                            document={document.node}
                            viewDocuments={() => this.viewDocuments(documentEdges, idx)}
                            refetchQuery={this.props.refetchDocumentsQuery}
                            toggleSelectDoc={this.toggleSelectDoc}
                            isSelected={!!this.state.selectedDocs.find(d => d.id === document.node.id)}
                        />
                    ))) : !loading &&
                    <p className="danger">No Incident Document Found!</p>
                    }
                    {!loading && allIncidentDocuments?.pageInfo?.hasNextPage && (
                        <div className="w-100 text-right mt-3">
                            <Button
                                color="primary"
                                size="sm"
                                onClick={() => {
                                    this.props.loadMoreEntries && this.props.loadMoreEntries()
                                }}
                            >
                                Load More
                            </Button>
                        </div>
                    )}
                </div>
                {/* Car Pictures */}
                {this.props.viewType === "incident" && allCarPictures?.edges?.length > 0 && (
                    <>
                        <h4 style={{ marginTop: 20 }}>Inspection Documents</h4>
                        <div className="DocumentCardContainer">
                            {allCarPictures.edges.map((pic, idx) => (
                                <Card className="DocumentCard" key={`inspect-${idx}`}>
                                    <div className="DocumentCardHeader">
                                        <p className="DocumentCardTitle">
                                            <span><i className="fa fa-picture-o" /></span>&nbsp;&nbsp;
                                            <span>{pic.node.pictureType || "Inspection Photo"}</span>
                                        </p>
                                        <span>
                                            {isImage(cleanDocumentUrl(pic.node.pictureUrl)) &&
                                                <>
                                                    <input
                                                        type="checkbox"
                                                        className="doc-select-checkbox"
                                                        checked={!!this.state.selectedDocs.find(d => d.id === pic.node.id)}
                                                        onClick={(e) => e.stopPropagation()}
                                                        onChange={() =>
                                                            this.toggleSelectDoc({
                                                                id: pic.node.id,
                                                                pictureUrl: pic.node.pictureUrl,
                                                                documentType: { typeName: pic.node.pictureType || "Inspection Photo" }
                                                            })
                                                        }
                                                    />&nbsp;&nbsp;
                                                </>
                                            }
                                            <i className="fa fa-arrows-alt" id={`view_full_document_${idx}`}
                                                onClick={() => this.viewDocuments(allCarPictures.edges, idx)}
                                            />
                                            <UncontrolledTooltip placement="top" target={`view_full_document_${idx}`}>View Full Document</UncontrolledTooltip>
                                        </span>
                                    </div>
                                    <div className="DocumentCardPreview">
                                        {isImage(cleanDocumentUrl(pic.node.pictureUrl)) ? (
                                            <img className="DocumentCardPreviewEmbed DocViewerImage" src={cleanDocumentUrl(pic.node.pictureUrl)} alt="Inspection" />
                                        ) : (
                                            <iframe className="DocumentCardPreviewEmbed" src={cleanDocumentUrl(pic.node.pictureUrl)} title={`inspection-iframe-${idx}`} />
                                        )}
                                    </div>
                                    <div className="DocumentCardFooter">
                                        <p className="mb-0" style={{ color: "black", fontWeight: 300 }}>
                                            Added: {pic.node.dateAdded ? <DatetimeRenderer datetime={pic.node.dateAdded} /> : "--"}
                                        </p>
                                        <p className="mb-0" style={{ color: "black", fontWeight: 300 }}>
                                            {pic.node.description || "---"}
                                        </p>
                                    </div>
                                </Card>
                            ))}
                        </div>
                    </>
                )
                }
            </>
        )
    }
}

export default withApolloClient(
    graphql(AllCarPicturesQuery, {
        options: ({ id }) => ({
            variables: { incidentId: id },
            fetchPolicy: "network-only"
        }),
        props: ({ data: { allCarPictures, loading } }) => ({
            allCarPictures,
            picturesLoading: loading
        })
    })(
        graphql(AllIncidentDocumentsQuery, {
            options: ({ id, isArchived, slug }) => ({
                variables: { incidentId: id, slug, isArchived, first: 5 },
                fetchPolicy: "network-only",
                notifyOnNetworkStatusChange: true,
            }),
            props({ data: { allIncidentDocuments, loading, refetch, fetchMore, variables } }) {
                return {
                    loading,
                    allIncidentDocuments,
                    variables,
                    refetch,
                    refetchDocumentsQuery: () =>
                        fetchMore({
                            query: AllIncidentDocumentsQuery,
                            variables: { ...variables, first: 5 },
                            updateQuery: (_, { fetchMoreResult }) => {
                                const newEdges = fetchMoreResult?.allIncidentDocuments?.edges || []
                                const pageInfo = fetchMoreResult?.allIncidentDocuments?.pageInfo
                                return {
                                    allIncidentDocuments: {
                                        edges: [...newEdges],
                                        pageInfo,
                                        __typename: "AllIncidentDocuments"
                                    }
                                }
                            }
                        }),
                    loadMoreEntries: () =>
                        fetchMore({
                            query: AllIncidentDocumentsQuery,
                            variables: {
                                after: allIncidentDocuments.pageInfo.endCursor,
                                ...variables
                            },
                            updateQuery: (prev, { fetchMoreResult }) => {
                                const newEdges = fetchMoreResult?.allIncidentDocuments?.edges || []
                                const pageInfo = fetchMoreResult?.allIncidentDocuments?.pageInfo
                                return {
                                    allIncidentDocuments: {
                                        edges: [...prev.allIncidentDocuments.edges, ...newEdges],
                                        pageInfo,
                                        __typename: prev.allIncidentDocuments.__typename
                                    }
                                }
                            }
                        })
                }
            }
        })(DocumentList)
    )
)
